import React, { Fragment, useEffect } from 'react';
import { I18nProvider, useLingui } from '@lingui/react';
import { i18n } from '@lingui/core';
export function getI18nInstance() {
  return i18n;
}
export default function TranslationsProvider(_ref) {
  let {
    children,
    locale,
    onActivate
  } = _ref;
  useEffect(() => {
    onActivate(locale);
  }, [locale, onActivate]);
  return /*#__PURE__*/React.createElement(I18nProvider, {
    i18n: i18n
  }, /*#__PURE__*/React.createElement(I18nWatchLocale, null, children));
}

function I18nWatchLocale(_ref2) {
  let {
    children
  } = _ref2;
  const {
    i18n
  } = useLingui(); // Skip render when locale isn't loaded

  if (!i18n.locale) return null; // Force re-render when locale changes. Otherwise string translations (e.g.
  // t`Macro`) won't be updated.

  return /*#__PURE__*/React.createElement(Fragment, {
    key: i18n.locale
  }, children);
}

TranslationsProvider.defaultProps = {
  onActivate: () => {}
};